import {Target, Shield, Smartphone} from 'lucide-react'

const VALUES = [
  {
    icon: <Target className="w-6 h-6" />,
    title: "Precision First",
    description: "Every calculator uses breed-specific data and industry-standard formulas to deliver the most accurate results for your operation.",
  },
  {
    icon: <Shield className="w-6 h-6" />,
    title: "Built for Farmers",
    description: "Designed with large buttons, high-contrast text, and mobile-first layouts so you can use these tools right in the field.",
  },
  {
    icon: <Smartphone className="w-6 h-6" />,
    title: "Always Free",
    description: "CowCalculator.com is 100% free with no sign-up required. Bookmark it on your home screen for instant access during calving season.",
  },
]

export default function AboutSection() {
  return (
    <section id="about" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Text Content */}
          <div>
            <span className="inline-block text-[#40916C] text-xs sm:text-sm font-semibold tracking-widest uppercase mb-3">
              About CowCalculator.com
            </span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#283618] leading-tight">
              Dedicated to Precision{" "}
              <span className="text-[#2D6A4F]">Livestock Management</span>
            </h2>
            <p className="mt-4 text-[#606C38] text-base sm:text-lg leading-relaxed">
              CowCalculator.com was built by cattle enthusiasts who understand that successful ranching starts with accurate data. Whether you are tracking a cow pregnancy calculator result, estimating your cattle birth calculator timeline, or planning your calving season, our tools give you the precision you need.
            </p>
            <p className="mt-3 text-[#606C38] text-base sm:text-lg leading-relaxed">
              From the cow due date calculator to advanced dairy ration formulations, we are building the most comprehensive suite of free livestock calculators on the web. No ads, no paywalls, no sign-ups — just tools that work.
            </p>

            {/* CTA */}
            <div className="mt-8 bg-gradient-to-r from-[#2D6A4F] to-[#40916C] rounded-xl p-5 sm:p-6">
              <p className="text-[#FEFAE0] font-bold text-base sm:text-lg" style={{ fontFamily: "'Merriweather', serif" }}>
                Bookmark this tool on your home screen for quick access in the field.
              </p>
              <p className="text-[#B7E4C7] text-sm mt-1">
                Press Ctrl+D (Windows) or Cmd+D (Mac) to save CowCalculator.com
              </p>
            </div>
          </div>

          {/* Values Cards */}
          <div className="space-y-4 sm:space-y-5">
            {VALUES.map((value, index) => (
              <div
                key={value.title}
                className="flex gap-4 sm:gap-5 p-5 sm:p-6 bg-[#FEFAE0] rounded-xl border border-[#B7E4C7]/40 hover:shadow-md hover:shadow-[#2D6A4F]/5 transition-all duration-300 hover:-translate-y-0.5"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="w-12 h-12 rounded-xl bg-[#2D6A4F]/10 flex items-center justify-center shrink-0 text-[#2D6A4F]">
                  {value.icon}
                </div>
                <div>
                  <h3 className="font-bold text-[#283618] text-base sm:text-lg">{value.title}</h3>
                  <p className="mt-1 text-sm sm:text-base text-[#606C38] leading-relaxed">{value.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
